"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackIcon = exports.NotificationsIcon = void 0;
var Notifications_1 = require("@material-ui/icons/Notifications");
Object.defineProperty(exports, "NotificationsIcon", { enumerable: true, get: function () { return __importDefault(Notifications_1).default; } });
var Feedback_1 = require("@material-ui/icons/Feedback");
Object.defineProperty(exports, "FeedbackIcon", { enumerable: true, get: function () { return __importDefault(Feedback_1).default; } });
//# sourceMappingURL=index.js.map